import { MILLION, PERCENT, TOTAL_MONTH } from './constant';

export const getMonthlyResult = (item, loading) => {
  if (!item || loading) {
    return {
      monthlyInstallment: '',
      annualRate: '',
    };
  }

  const {
    celOffer: { monthlyInstallmentAmount, annualInterestRate },
  } = item;

  const monthlyInstallment = new Intl.NumberFormat('de-DE').format(
    monthlyInstallmentAmount.amount,
  );
  const annualIR = (annualInterestRate / TOTAL_MONTH) * PERCENT;
  const annualRate = `${annualIR.toFixed(2)} %`;
  const dailyInstallment = new Intl.NumberFormat('de-DE').format(
    Math.ceil(monthlyInstallmentAmount.amount / 30 / 1000) * 1000,
  );
  return {
    monthlyInstallment,
    annualRate,
    dailyInstallment,
  };
};

export const getAmountList = amount => {
  const list = Array.from(Array(amount).keys()).map(item => ({
    key: item,
    value: item * MILLION,
    label: `${item} triệu`,
  }));
  list.splice(0, 5);
  return list;
};

export const getAmountObj = amounts =>
  amounts.reduce((result, item) => ({ ...result, [item.key]: item }), {});

export const getDefaultAmount = value => +value * MILLION;
